// extracted by mini-css-extract-plugin
module.exports = {"paymentImages":"paymentProviders_paymentImages__rgsdd"};